import { BaseServices, HttpMethod } from '@services/base'
import { Endereco } from '@store/refinanciamento/endereco/types'

import { BridgeService } from './bridge'

export default (cep: string, accessToken?: string) => {
  const pathname = `${process.env.REACT_APP_ZIPCODE_BFF}?cep=${cep}`
  const method = HttpMethod.GET
  const host = process.env.REACT_APP_API_HOST
  const headers: Record<string, string> = {}

  if (BridgeService.isBrowser() && accessToken) {
    headers.Authorization = `Bearer ${accessToken}`
  }

  const response = BaseServices.request<Endereco>({
    headers,
    pathname,
    method,
    host,
  })
  return response
}
